import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import HeaderMenu from "./sidebar/headermenu";
import RightWrap from "./rightside/right_wrap";
import SinglePostWrap from "./posts/single_post_wrap";
import DummyMenu from "./sidebar/dummymenu";
import LoginModel from "./login/login_model";

export default function SinglePost() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const [login, setLogin] = useState(false);

    const params = useParams({ postId: String });

    useEffect(() => {
        const token = localStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            setLogin(false);
        } else {
            setLogin(true);
        }
    }, []);

    const ulogout = () => {
        sessionStorage.removeItem('LOGIN_TOKEN');
        navigate('/login');
    }

    return <div id="wrapper">
        {
            login &&
            <HeaderMenu />
        }
        {
            !login &&
            <DummyMenu />
        }
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="main__inner">
                <div className="flex max-lg:flex-col xl:gap-10 md:gap-3 md:mt-10" id="js-oversized">
                    <SinglePostWrap postid={params.postId} />
                    {
                        login &&
                        <RightWrap />
                    }
                    {
                        !login &&
                        <div className="lg:max-w-[370px] md:max-w-[510px] mx-auto">
                            <div className="xl:space-y-6 space-y-3 md:pb-12" uk-sticky="end: #js-oversized; offset: 50; media:992"></div>
                        </div>
                    }
                </div>
            </div>
        </main>
        {
            !login &&
            <div style={{ position:'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#ffffffb4' }}>
                <LoginModel />
            </div>
        }
    </div>

}